import { render } from "./FaceTopMatter.vue?vue&type=template&id=252774db&ts=true"
import script from "./FaceTopMatter.vue?vue&type=script&lang=ts"
export * from "./FaceTopMatter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__